import "core-js/modules/es6.function.name.js";
export default {
  name: 'MdmIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: '50'
    },
    width: {
      type: String,
      default: 'width'
    },
    height: {
      type: String,
      default: 'height'
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName: function iconName() {
      return "#".concat(this.name);
    },
    currentWidth: function currentWidth() {
      return this.width !== 'width' ? this.width : this.size;
    },
    currentHeight: function currentHeight() {
      return this.height !== 'height' ? this.height : this.size;
    },
    viewBox: function viewBox() {
      return "0 0 ".concat(this.currentWidth, " ").concat(this.currentHeight);
    }
  }
};